const logoIdentity = (logo) =>
  logo?._id || logo?.key || logo?.url || logo?.thumbnail || logo?.name || null;

export const logoUploadedTime = (logo) => {
  const uploadedAt = logo?.uploadedAt
    ? new Date(logo.uploadedAt).getTime()
    : NaN;
  if (!Number.isNaN(uploadedAt) && uploadedAt > 0) return uploadedAt;
  return 0;
};

const newestLogo = (logos = []) => {
  const stamped = logos.filter((logo) => logoUploadedTime(logo) > 0);
  const candidates = stamped.length ? stamped : logos;
  if (!candidates.length) return null;

  return candidates.reduce((newest, logo) =>
    logoUploadedTime(logo) >= logoUploadedTime(newest) ? logo : newest,
  );
};

export const sortLogosNewestFirst = (logos = []) =>
  [...(Array.isArray(logos) ? logos : [])].sort(
    (a, b) => logoUploadedTime(b) - logoUploadedTime(a),
  );

export const getUploadedLogo = (responseData, projectId) => {
  const projectLogos = responseData?.project?.logos || [];
  const uploadedLogos = responseData?.uploadedLogos || [];
  const uploadedLogo =
    newestLogo(projectLogos) || newestLogo(uploadedLogos);

  if (!uploadedLogo) return null;

  return {
    ...uploadedLogo,
    project_id: uploadedLogo.project_id || projectId,
  };
};

export const mergeUploadedLogo = (currentLogos, uploadedLogo) => {
  if (!uploadedLogo) return currentLogos || [];

  const uploadedIdentity = logoIdentity(uploadedLogo);
  const logos = Array.isArray(currentLogos) ? currentLogos : [];

  return [
    uploadedLogo,
    ...logos.filter((logo) => logoIdentity(logo) !== uploadedIdentity),
  ];
};
